import React, { useCallback } from 'react'
import { intl } from 'lang/intl'

import { TtButton, TtIcon, TtTooltip } from '@23/react'

import {
  enableParticipantAudio,
  toggleParticipantAudio,
} from '../../../../webrtc/blocs/audioMuting'
import { useLocalParticipant } from '../../../../webrtc/webRTCRoom'
import { useOpenDeviceSelector } from '../../../../Devices/components/DeviceSelector/DeviceSelector'
import { changeSelectedDevices } from '../../../../Devices/useDevices'

export const Microphone = () => {
  const openDeviceSelector = useOpenDeviceSelector()
  const localParticipant = useLocalParticipant()

  const audioTrack = localParticipant?.tracks.cameraAudio
  const isMuted = !audioTrack?.isEnabled

  const getTooltipContent = useCallback(() => {
    return isMuted
      ? intl.formatMessage({ defaultMessage: 'You are muted' })
      : intl.formatMessage({ defaultMessage: 'Click to mute your mic' })
  }, [isMuted])

  type ButtonColor = HTMLTtButtonElement['color']

  const getAriaLabel = useCallback(() => {
    return isMuted
      ? intl.formatMessage({ defaultMessage: 'Click to unmute' })
      : intl.formatMessage({ defaultMessage: 'Click to mute your mic' })
  }, [isMuted])

  const toggleAudio = useCallback(async () => {
    if (!localParticipant?.id) return
    if (!localParticipant.tracks.cameraAudio) {
      const devicesSelected = await openDeviceSelector()
      changeSelectedDevices(devicesSelected)
      enableParticipantAudio(localParticipant.id)
    } else {
      await toggleParticipantAudio(localParticipant.id)
    }
  }, [
    localParticipant?.id,
    localParticipant?.tracks.cameraAudio,
    openDeviceSelector,
  ])

  const buttonColor: ButtonColor = isMuted ? 'danger' : 'secondary'
  const iconName = isMuted ? 'mic-off' : 'mic-on'

  if (!localParticipant) return null

  return (
    <TtTooltip content={getTooltipContent()} placement="left" distance={16}>
      <TtButton
        circle
        color={buttonColor}
        onClick={toggleAudio}
        aria-label={getAriaLabel()}
      >
        <TtIcon library="one/webinars" name={iconName} />
      </TtButton>
    </TtTooltip>
  )
}
